/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */

export type FeatureFlagName = typeof FeatureFlagName[keyof typeof FeatureFlagName];


export const FeatureFlagName = {
  FLEET_LOGISTICS: 'fleet_logistics',
  FLEET_MISSION_BUILDER: 'fleet_mission_builder',
  FLEET_STARMAP: 'fleet_starmap',
  FLEET_WORLDMAP: 'fleet_worldmap',
  HANGAR_INVENTORIES: 'hangar_inventories',
  OAUTH_APPLICATIONS: 'oauth-applications',
  OAUTH_BLUESKY: 'oauth-bluesky',
  OAUTH_CITIZENID: 'oauth-citizenid',
  OAUTH_DISCORD: 'oauth-discord',
  OAUTH_GITHUB: 'oauth-github',
  OAUTH_GOOGLE: 'oauth-google',
  OAUTH_TWITCH: 'oauth-twitch',
  SHIP_INVENTORIES: 'ship_inventories',
  TOOLS_CARGO_GRIDS: 'tools_cargo_grids',
  TOOLS_TRAVEL_TIMES: 'tools_travel_times',
} as const;
